import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as MaterialSelect,
  SelectProps
} from '@mui/material';

export type SelectFormData = {
  value: any;
  label: string | number;
};

type SelectComponentProps = Omit<SelectProps<any>, 'margin'> & {
  data: SelectFormData[];
  helperText?: any;
  margin?: 'normal' | 'dense' | 'none';
};
export function Select({
  data,
  label,
  name,
  fullWidth,
  error,
  helperText,
  margin = 'normal',
  ...props
}: SelectComponentProps) {
  return (
    <FormControl
      sx={{ minWidth: 120 }}
      error={error}
      margin={margin}
      fullWidth={fullWidth}
    >
      {!!label && <InputLabel id={name}>{label}</InputLabel>}
      <MaterialSelect
        labelId={name}
        error={error}
        name={name}
        label={label}
        fullWidth={fullWidth}
        {...props}
      >
        {data.map((item) => {
          return (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          );
        })}
      </MaterialSelect>
      {helperText}
    </FormControl>
  );
}
